import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion as MuiAccordion } from '@mui/material';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';

const Accordion = ({ id, header, body, actions, dense, ...restProps }) => {
  return (
    <MuiAccordion {...restProps} aria-label="accordion">
      <AccordionSummary
        id={id}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        aria-label="accordion-summary"
      >
        {header}
      </AccordionSummary>
      <AccordionDetails
        aria-label="accordion-details"
        style={dense ? { padding: 0 } : {}}
      >
        {body}
      </AccordionDetails>
      {actions && (
        <>
          <Divider />
          <AccordionActions aria-label="accordion-actions">
            {actions}
          </AccordionActions>
        </>
      )}
    </MuiAccordion>
  );
};

Accordion.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  body: PropTypes.node.isRequired,
  actions: PropTypes.node,
  dense: PropTypes.bool,
};

export default Accordion;
